import React, {useState} from 'react';

export default function HelpOption(props){
      return (
      <span>
        {"The options list is ordered by score. The list updates automaticly as you set your prefernces. Click on an option to see more data."}
      </span>);
}
